

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "TeamModal",
  components: {}
})
export default class TeamModal extends Vue {
  @Prop() readonly show: any;
  close() {
    this.$emit("close");
  }
}
